
class AppLocalStorage {

  constructor() {
  }
  say(){
    alert("hello");
  }
  /**
   * 存储用户数据
   * */
  storeUserData(data){
    /**
     {
        "code":200000,
        "msg":"success",
        "data":{
            "user":"790092348@qq.com",
            "token":"39888da3-631e-498e-9b4b-9713f168f6b0"
        }
     }
     *  */
    localStorage.setItem("userData",JSON.stringify(data));
  }
  getUserData(){
    let userDataStr = localStorage.getItem("userData");
    if(userDataStr==undefined){
      return undefined;
    }
    return JSON.parse(userDataStr);
  }
  getUserMailbox(){
    let userDataStr = localStorage.getItem("userData");
    if(userDataStr==undefined){
      return undefined;
    }

    if(userDataStr == 'undefined'){
      return  undefined;
    }

    let objUser =  JSON.parse(userDataStr);
    return objUser["user"];
  }

  userLogout(){
    localStorage.removeItem("userData");
  }

  remove(dataKey){
    localStorage.removeItem(dataKey)
  }

}

export default AppLocalStorage;



// WEBPACK FOOTER //
// ./src/components/AppLocalStorage.js